export const environment = {
  env: "prod",
  production: true,
  backendEndpoint: "https://app-backend.hub.bizcuit.nl"
};
